import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getUnreadMessageCount } from "./../service/account";

interface AppState {
  unreadMessages: {
    feedback: number;
  };
  getUnreadMessages: () => void;
}

const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      unreadMessages: {
        feedback: 0,
      },
      getUnreadMessages: async () => {
        const res = await getUnreadMessageCount();
        set({ unreadMessages: res.data });
        // set({
        //   unreadMessages: {
        //     feedback: 3,
        //   },
        // }); // TODO: 移除假数据
      },
    }),
    {
      name: "awsdk-web-app-v1",
    }
  )
);

export default useAppStore;
